export default __webpack_public_path__ + "static/media/male-logo.8d459612.svg";